document.addEventListener("DOMContentLoaded", function () {
  // 1. Selectors (Merged with your new specific selectors)
  const openToggle =
    document.querySelector(".open-overlay") ||
    document.querySelector(".drawer-toggle") ||
    document.querySelector('[aria-label="Open Menu"]');
  const closeToggle = document.querySelector(".close-overlay");
  const drawer =
    document.querySelector(".overlay-menu-container") ||
    document.querySelector(".site-drawer") ||
    document.getElementById("section-21-14");
  const overlay = document.querySelector(".site-drawer-overlay");

  // 2. Core Open/Close Function
  function setDrawer(open) {
    // Add/remove classes
    if (drawer) drawer.classList.toggle("open", open);
    document.body.classList.toggle("drawer-open", open);

    // Lock/unlock scrolling
    const overflowValue = open ? "hidden" : "";
    document.documentElement.style.overflow = overflowValue;
    document.body.style.overflow = overflowValue;

    // Accessibility updates
    if (openToggle)
      openToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (drawer) drawer.setAttribute("aria-hidden", open ? "false" : "true");

    // Return focus to the toggle button when closing (Accessibility enhancement)
    if (!open && openToggle) {
      openToggle.focus();
    }

    // Scroll to top if opening
    if (open) window.scrollTo(0, 0);
  }

  // 3. Event Listeners for Opening
  if (openToggle) {
    openToggle.addEventListener("click", () => {
      const isOpen = openToggle.getAttribute("aria-expanded") === "true";
      setDrawer(!isOpen);
    });
  }

  // 4. Event Listeners for Closing
  if (closeToggle) {
    closeToggle.addEventListener("click", () => setDrawer(false));
  }

  if (overlay) {
    overlay.addEventListener("click", () => setDrawer(false));
  }

  // Close menu on Escape key press (Updated to check if currently open)
  document.addEventListener("keydown", (e) => {
    const isOpen =
      openToggle && openToggle.getAttribute("aria-expanded") === "true";
    if (e.key === "Escape" && isOpen) {
      setDrawer(false);
    }
  });

  // 5. Menu Cloning Logic
  const navMenu = document.querySelector(".nav-menu");
  if (navMenu && drawer && !drawer.querySelector(".drawer-menu")) {
    const drawerMenu = navMenu.cloneNode(true);
    drawerMenu.innerHTML = drawerMenu.innerHTML.replaceAll(
      "nav-menu",
      "drawer-menu",
    );
    drawerMenu.classList.remove("nav-menu");
    drawerMenu.classList.add("drawer-menu");
    drawer.appendChild(drawerMenu);
  }
});
